import { useMemo } from "react";
import useLabels from "./useLabels";
import { tableTypeOptions } from "../customComponents/TableTypeAutocomplete";
import { TableType } from "../components/modules/customer/companies/queries/types";

const useTableTypeOptions = () => {
  const { companyLabel, subsidiaryLabel, subsidiarySiteLabel, junctionLabel } =
    useLabels();
  const tableTypeOptions: tableTypeOptions[] = useMemo(() => {
    return [
      {
        label: companyLabel,
        value: TableType.COMPANY,
      },
      {
        label: subsidiaryLabel,
        value: TableType.SUBSIDIARY,
      },
      {
        label: subsidiarySiteLabel,
        value: TableType.SITE,
      },
      {
        label: junctionLabel,
        value: TableType.JUNCTION,
      },
    ];
  }, [companyLabel, subsidiaryLabel, subsidiarySiteLabel, junctionLabel]);

  return { tableTypeOptions };
};

export default useTableTypeOptions;
